var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "x_circle",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 47.9 47.9",
    style: {
      enableBackground: "new 0 0 47.9 47.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#3E1293;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st1{fill:none;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    className: "st0",
    d: "M42.1,23.9c0,10-8.1,18.1-18.1,18.1S5.8,34,5.8,23.9c0-10,8.1-18.1,18.1-18.1 C33.9,5.8,42.1,13.9,42.1,23.9C42.1,23.9,42.1,23.9,42.1,23.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    className: "st0",
    d: "M32.6,15.2L15.2,32.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    className: "st0",
    d: "M15.2,15.2l17.4,17.4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    className: "st1",
    d: "M0,0h47.9v47.9H0V0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f524e431b2845f7f32edc970a64cf002.svg";
export { ForwardRef as ReactComponent };